import {createFileRoute} from '@tanstack/react-router';

import {OrganizationsPage} from '@/modules/admin/pages/OrganizationsPage';

export const Route = createFileRoute('/_authenticated/admin/organizations/')({
  component: OrganizationsPage,
});
